import { Directive, HostListener, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { InstrumentationService } from '../../services/instrumentation.service';
import { LinkedPropertyUtility } from '../../../../shared/utils/linked-property.utility';
import { ClientInstrumentationEventType, IClientProps } from '../../../../shared/interfaces/client-instrumentation.interface';

/**
 * Directive to instrument user interactions by sending events via InstrumentationApi.
 *
 * Usage example:
 * ```html
 * <button
 *   [appInstrumentAction]="'Add component'"
 *   [instrumentEventProps]="{ componentId: '123' }">
 *   Add Component
 * </button>
 * ```
 *
 * The directive automatically extracts workspaceId and digitalPropertyId from query parameters.
 */
@Directive({
  selector: '[appInstrumentAction]',
  standalone: false,
})
export class InstrumentActionDirective {
  /** The event name to send when the element is clicked */
  @Input() public appInstrumentAction: ClientInstrumentationEventType | undefined | null;

  /** Additional properties to include with the event */
  @Input() public instrumentEventProps: IClientProps = {};

  constructor(
    private instrumentationService: InstrumentationService,
    private activatedRoute: ActivatedRoute,
  ) {}

  @HostListener('click')
  public onClick(): void {
    if (!this.appInstrumentAction) {
      return;
    }

    const queryParams = this.activatedRoute.snapshot.queryParams;
    const { workspaceId, digitalPropertyId } = LinkedPropertyUtility.fromLinkedPropertyQueryParam(queryParams);

    this.instrumentationService.track(this.appInstrumentAction, this.instrumentEventProps, workspaceId, digitalPropertyId);
  }
}
